import cx from "classnames";
import { useMemo } from "react";
import { Link } from "react-router-dom";
import type { Address } from "viem";

import { useGetTraderDetail } from "lib/apis/referral";
import { buildAccountDashboardUrl } from "pages/AccountDashboard/buildAccountDashboardUrl";

import AddressView from "components/AddressView/AddressView";
import TooltipWithPortal from "components/Tooltip/TooltipWithPortal";

function normalizeUsername(username?: string) {
  const value = username?.trim();
  if (!value) return undefined;
  return value.replace(/^@+/, "");
}

export function LeaderboardIdentityCell({
  address,
  preferredUsername,
  big,
}: {
  address: string;
  preferredUsername?: string;
  big?: boolean;
}) {
  const { data: traderDetail } = useGetTraderDetail(address.toLowerCase(), {
    staleTime: 60_000,
    refetchInterval: 120_000,
    retry: 1,
  });

  const username = useMemo(
    () => normalizeUsername(preferredUsername) ?? normalizeUsername(traderDetail?.referral_code),
    [preferredUsername, traderDetail?.referral_code]
  );

  if (!username) {
    return <AddressView big={big} size={20} address={address} breakpoint="XL" />;
  }

  return (
    <TooltipWithPortal
      position="bottom-start"
      handle={
        <Link
          target="_blank"
          to={buildAccountDashboardUrl(address as Address, undefined, 2)}
          className={cx("font-medium text-white hover:text-primary-alpha-darker", {
            "text-body-large": big,
            "text-body-medium": !big,
          })}
        >
          @{username}
        </Link>
      }
      content={<span className="font-medium">{address}</span>}
    />
  );
}
